<h2 mat-dialog-title>Confirmation</h2>
<mat-dialog-content class="mat-typography">
  @if(data){
  <p>Are you sure you want to <b>{{data.action}}</b> this record:</p>
  <details>
    <summary>Record Details</summary>
    <ul>
      @for(field of data.elements; track field){
      <li>
        <b>{{field.displayName}}:</b>
        @if(field.renderType.element === 'date-picker'){
        {{field.value | date:'MMM dd, yyyy'}}
        }
        @else{
        {{field.value}}
        }
      </li>
      }
    </ul>
  </details>
  
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton mat-dialog-close>Cancel</button>
  <button matButton [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
